import { TasksApi } from '../api-clients';
import { wrap } from '../wrap';

export const taskApi = {
  show: wrap(TasksApi, TasksApi.prototype.showTask),
  create: wrap(TasksApi, TasksApi.prototype.createTask),
  update: wrap(TasksApi, TasksApi.prototype.updateTask),
  move: wrap(TasksApi, TasksApi.prototype.moveTask),
};
